
interface Options {
  // the height of the visible scrolling window
  visibleHeight: number
  // full scrollable content with margin and padding
  contentHeight: number
}

export function scrollCalculator({visibleHeight, contentHeight}: Options) {

  return (scrollTop: number) => {

    if (contentHeight === 0) {
      return 1.
    }

    if (visibleHeight >= contentHeight) {
      return 1.
    }

    return (scrollTop + visibleHeight) / contentHeight
  }
}
